import styles from './NotifyForm.module.scss';
import {
  Form,
  FormGroupLabel,
  FormRadio,
  FormRadioGroup,
  FormSubmit,
} from '@ariakit/react';
import { Button, Content, InputField, Radio } from '@wienenergiegithub/ui-next';
import React from 'react';
import PropTypes from 'prop-types';

const NotifyForm = ({ store }) => (
  <Form store={store}>
    <FormRadioGroup className={styles.field} name="gender" store={store}>
      <FormGroupLabel
        className={styles.radioLabel}
        name="gender"
        render={<legend />}
        store={store}
      >
        Anrede
      </FormGroupLabel>
      <div className={styles.radios}>
        <FormRadio
          label="Frau"
          name="gender"
          render={<Radio label="Frau" />}
          required
          store={store}
          value="frau"
          variant="horizontal"
        />
        <FormRadio
          label="Herr"
          name="gender"
          render={<Radio label="Herr" />}
          required
          store={store}
          value="herr"
          variant="horizontal"
        />
        <FormRadio
          label="Divers"
          name="gender"
          render={<Radio label="Divers" />}
          required
          store={store}
          value="divers"
          variant="horizontal"
        />
      </div>
    </FormRadioGroup>
    <InputField
      className={styles.field}
      label="Vorname"
      name="firstname"
      required
      store={store}
    />
    <InputField
      className={styles.field}
      label="Nachname"
      name="lastname"
      required
      store={store}
    />
    <InputField
      className={styles.field}
      label="E-Mail-Adresse"
      name="email"
      required
      store={store}
    />
    <Content className={styles.legalText} size="sm">
      Durch das Anklicken des „Speichern“ Buttons stimme ich zu, dass meine
      bekanntgegebenen personenbezogenen Daten (Name, Anrede, Anschrift und
      E-Mail-Adresse) von der Wien Energie GmbH zum Zweck der Kontaktaufnahme
      via Email zur Verfügbarkeit von SuperSchnell verarbeitet werden dürfen.
    </Content>
    <Content className={styles.legalText} size="sm">
      Sie können diese Einwilligung jederzeit durch ein E-Mail an{' '}
      <a href="mailto:datenschutz@wienenergie.at">datenschutz@wienenergie.at</a>{' '}
      widerrufen. Durch den Widerruf der Einwilligung wird die Rechtmäßigkeit
      der aufgrund der Einwilligung bis zum Widerruf erfolgten Verarbeitung
      nicht berührt. Bitte entnehmen Sie weitere Informationen zur Verarbeitung
      Ihrer Daten der <a href="/datenschutz">Datenschutzerklärung</a>.
    </Content>
    <div className={styles.buttonContainer}>
      <FormSubmit
        className={styles.submitButton}
        render={<Button isElevated>Speichern</Button>}
        store={store}
      />
    </div>
  </Form>
);

NotifyForm.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  store: PropTypes.object,
};

export { NotifyForm };
